import request from '@/utils/request'

export function verifyVideoInfo(id) {
  return request({
    url: '/comment/verifyVideo',
    method: 'get',
    params:{ id: id }
  })
}export function verifyInfo(id) {
  return request({
    url: '/comment/verifyInfo',
    method: 'get',
    params:{ id: id }
  })
}export function updatePlay(id) {
  return request({
    url: '/comment/updatePlay',
    method: 'get',
    params:{ id: id }
  })
}
export function verifyVideoAndPlay(id) {
  return request({
    url: '/comment/verifyVideoAndPlay',
    method: 'get',
    params:{ id: id }
  })
}
export function getVideoCategory() {
  return request({
    url: '/frontEnd/videoCategory',
    method: 'get'
  })
}
export function commitComment(param) {
  return request({
    url: '/comment/commitComment',
    method: 'post',
    params: param
  })
}
export function commitReply(param) {
  return request({
    url: '/comment/commitReply',
    method: 'post',
    params: param
  })
}
export function getComments(id,order) {
  return request({
    url: '/comment/videoComments/'+id,
    method: 'get',
    params:{order:order}
  })
}
export function addLike(id) {
  return request({
    url: '/member/addLike/'+id,
    method: 'get'
  })
}
export function addCommentLike(id) {
  return request({
    url: '/member/addCommentLike/'+id,
    method: 'get'
  })
}
export function verifyIfBuy(id) {
  return request({
    url: '/comment/verifyIfBuy/'+id,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/videoDetail.js